import type { RouteRecordRaw } from 'vue-router'
import { prefixRoutes, route } from '@/router/utils'
import type { Options } from '@/router'
import { i18n } from '@/i18n'
import { receiveRoute } from '@m/cabinet/components/views/utils'
import Receive from '@m/cabinet/components/views/Receive.vue'

import { serviceModerationApi } from '@/services/serviceModeration.service'
import { servicesAdminDetailResource } from '@/services/services.service'

export const STAFF_SERVICES_MODEL_PATH = 'services/'

export const STAFF_SERVICES_VIEW_NAME = 'staff:services'

const STAFF_SERVICES_MODERATION_PREFIX = `${STAFF_SERVICES_VIEW_NAME}:moderation`
const STAFF_SERVICES_PREFIX = `${STAFF_SERVICES_VIEW_NAME}:services`

const mPrefix = (name: string) => STAFF_SERVICES_MODERATION_PREFIX + ':' + name
const sPrefix = (name: string) => STAFF_SERVICES_PREFIX + ':' + name

export const STAFF_SEVICES_MODERATION_LIST_VIEW_NAME = mPrefix('list')
export const STAFF_SEVICES_MODERATION_VIEW_VIEW_NAME = mPrefix('view')
export const STAFF_SEVICES_MODERATION_GENERAL_VIEW_NAME = mPrefix('general')
export const STAFF_SEVICES_MODERATION_DESCRIPTION_VIEW_NAME =
  mPrefix('description')

const ServicesModerationListView = () => import('./ModerationServices/List.vue')
const ServicesModerationViewView = () => import('./ModerationServices/View.vue')
const ServicesModerationGeneralView = () =>
  import('./ModerationServices/tabs/General.vue')
const ServicesModerationDescriptionView = () =>
  import('./ModerationServices/tabs/Description.vue')

export const STAFF_LOCAL_SERVICES_LIST_VIEW_NAME = sPrefix('list')
export const STAFF_LOCAL_SERVICES_IMPORTS_VIEW_NAME = sPrefix('imports')
export const STAFF_LOCAL_SERVICES_CREATE_VIEW_NAME = sPrefix('create')
export const STAFF_LOCAL_SERVICES_VIEW_NAME = sPrefix('view')
export const STAFF_LOCAL_SERVICES_GENERAL_VIEW_NAME = sPrefix('general')
export const STAFF_LOCAL_SERVICES_CLASSIFIERS_VIEW_NAME = sPrefix('classifiers')
export const STAFF_LOCAL_SERVICES_DESCRIPTION_VIEW_NAME = sPrefix('description')

const LocalServicesListView = () => import('./LocalServices/List.vue')
const LocalServicesImportsView = () =>
  import('./LocalServices/ServicesImports.vue')
const LocalServicesCreateView = () => import('./LocalServices/Create.vue')
const LocalServicesViewView = () => import('./LocalServices/View.vue')
const LocalServiceGeneralView = () => import('./LocalServices/tabs/General.vue')
const LocalServiceDescriptionView = () =>
  import('./LocalServices/tabs/Description.vue')

export function createServicesRoutes(options: Options): RouteRecordRaw[] {
  const { t: $t } = i18n.global

  return [
    prefixRoutes(
      'moderation/',
      [
        route(
          'list/',
          ServicesModerationListView,
          STAFF_SEVICES_MODERATION_LIST_VIEW_NAME,
          {
            meta: {
              title: () => $t('Requests for service creation'),
            },
          }
        ),
        receiveRoute(
          serviceModerationApi.detail,
          [
            prefixRoutes(
              '',
              [
                route(
                  'general/',
                  ServicesModerationGeneralView,
                  STAFF_SEVICES_MODERATION_GENERAL_VIEW_NAME,
                  {
                    meta: {
                      title: () => $t('Service moderation'),
                      isHideCabinetHead: true,
                      fallbackRouteName: {
                        name: STAFF_SEVICES_MODERATION_LIST_VIEW_NAME,
                        text: $t('All requests for service moderation'),
                      },
                    },
                  }
                ),
                route(
                  'description/',
                  ServicesModerationDescriptionView,
                  STAFF_SEVICES_MODERATION_DESCRIPTION_VIEW_NAME,
                  {
                    meta: {
                      title: () => $t('Service moderation'),
                      isHideCabinetHead: true,
                      fallbackRouteName: {
                        name: STAFF_SEVICES_MODERATION_LIST_VIEW_NAME,
                        text: $t('All requests for service moderation'),
                      },
                    },
                  }
                ),
              ],
              {
                name: STAFF_SEVICES_MODERATION_VIEW_VIEW_NAME,
                redirect: { name: STAFF_SEVICES_MODERATION_GENERAL_VIEW_NAME },
                meta: {},
                component: ServicesModerationViewView,
                props: {
                  resource: serviceModerationApi.detail,
                  resourceKey: 'id',
                  routeKey: 'facility',
                },
              }
            ),
          ],
          Receive,
          '',
          'service',
          'id',
          {
            isHideCabinetHead: true,
          }
        ),
      ],
      options
    ),

    // services
    prefixRoutes(
      'services/',
      [
        route(
          'create/',
          LocalServicesCreateView,
          STAFF_LOCAL_SERVICES_CREATE_VIEW_NAME,
          {
            meta: {
              title: () => $t('Create Berrdo service'),
            },
          }
        ),
        route(
          'imports/',
          LocalServicesImportsView,
          STAFF_LOCAL_SERVICES_IMPORTS_VIEW_NAME,
          {
            meta: {
              title: () => $t('Import Berrdo services'),
              fallbackRouteName: {
                name: STAFF_LOCAL_SERVICES_LIST_VIEW_NAME,
                text: $t('All services'),
              },
            },
          }
        ),
        route(
          'list/',
          LocalServicesListView,
          STAFF_LOCAL_SERVICES_LIST_VIEW_NAME,
          {
            meta: {
              title: () => $t('Berrdo services'),
            },
          }
        ),

        prefixRoutes(
          '',
          [
            {
              name: STAFF_LOCAL_SERVICES_VIEW_NAME,
              redirect: { name: STAFF_LOCAL_SERVICES_GENERAL_VIEW_NAME },
              ...(receiveRoute(
                servicesAdminDetailResource,
                [
                  prefixRoutes(
                    '',
                    [
                      route(
                        'general/',
                        LocalServiceGeneralView,
                        STAFF_LOCAL_SERVICES_GENERAL_VIEW_NAME,
                        {
                          meta: {
                            title: () => $t('Berrdo service'),
                            // isHideCabinetHead: true,
                            fallbackRouteName: {
                              name: STAFF_LOCAL_SERVICES_LIST_VIEW_NAME,
                              text: $t('All services'),
                            },
                          },
                        }
                      ),

                      // route(
                      //   'classfiers/',
                      //   FacilityStaffLicence,
                      //   FACILITY_STAFF_LICENCE_VIEW_NAME,
                      //   {
                      //     meta: {
                      //       title: () => $t('Berrdo service'),
                      //       isHideCabinetHead: true,
                      //       fallbackRouteName: {
                      //         name: STAFF_LOCAL_SERVICES_LIST_VIEW_NAME,
                      //         text: $t('All services'),
                      //       },
                      //     },
                      //   }
                      // ),
                      route(
                        'description/',
                        LocalServiceDescriptionView,
                        STAFF_LOCAL_SERVICES_DESCRIPTION_VIEW_NAME,
                        {
                          meta: {
                            title: () => $t('Berrdo service'),
                            // isHideCabinetHead: true,
                            fallbackRouteName: {
                              name: STAFF_LOCAL_SERVICES_LIST_VIEW_NAME,
                              text: $t('All services'),
                            },
                          },
                        }
                      ),
                    ],
                    {
                      name: STAFF_LOCAL_SERVICES_VIEW_NAME,
                      redirect: {
                        name: STAFF_LOCAL_SERVICES_GENERAL_VIEW_NAME,
                      },
                      meta: {},
                      component: LocalServicesViewView,
                      props: {
                        resource: servicesAdminDetailResource,
                        resourceKey: 'id',
                        routeKey: 'service',
                      },
                    }
                  ),
                ],
                Receive,
                '',
                'service',
                'id',
                {
                  // isHideCabinetHead: true,
                }
              ) as any),
            },
          ],
          {
            ...options,
          }
        ),
      ],
      options
    ),
  ]
}
